export default __webpack_public_path__ + "static/media/gopher.98882738.png";